<template>
	<div id="BookstoreBilling" class="bookstore-billing bg-aces">
		<div v-if="!loadingConfigurations">
			<header class="bg-aces">
				<input type="text"
					ref="inputPrincipal" class="input-principal text-white text-center"
					v-model="inputPrincipal"
					:class="(inputPrincipalFocus) ? '' : 'text-white-placeholder'"
					:disabled="disabledInputPrincipal"
					:placeholder="(inputPrincipalFocus) ? 'Listo!!!, comience a escribir o leer los codigos de barra' : 'Haz click aquí para comenzar'"
					@focus="actionInputPrincipalFocus"
					@blur="inputPrincipalFocus=false"
					@keydown.ctrl.80.prevent.stop="goToInputPrincipalKeydownCtrlLocal"
					@keydown.ctrl.83.prevent.stop="goToInputPrincipalKeydownCtrlLocal"
					@keydown.enter="searchSomething">
			</header>
			<main :style="'width:' + widthMain" @click="goToInputPrincipal" v-if="objectOrder.order_products.length > 0">
				<div class="list">
					<div v-for="(item, index) in objectOrder.order_products" :key="index" class="item row">
						<div class="col-5 it">
							<div class="text-white product-name">{{ item.product.name }}</div>
							<small class="text-white-50">SKU: {{ item.product.id }} - ISBN: {{ item.product.isbn }}</small>
						</div>
						<div class="col-2 it">
							<div class="row product-quantity">
								<div class="col-3 text-white product-quantity text-right">{{ item.quantity }} <span class="ml-2 text-secundary">x</span></div>
								<div class="col-9 it">
									<div class="text-white product-price text-right">$ {{ methodFormatNumber(item.price) }}</div>
								</div>
							</div>
						</div>
						<div class="col-2 it">
							<span class="text-white product-discount text-right align-middle">0</span>
						</div>
						<div class="col-3 it">
							<div class="row total-item">
								<div class="col-9">
									<div class="total-item">$ {{ methodFormatNumber(item.quantity * item.price) }}</div>
								</div>
								<div class="col-3 text-right icon">
									<i class="far fa-eye text-primary" title="Vizualizar Producto"></i>
									<i class="far fa-trash-alt pointer ml-1 text-brown-red" title="Quitar item" @click="deleteItemObjectOrderProductLocal(item, index)"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
			</main>
			<main v-else>
				<div class="mt-1 container">
					<div>
					</div>
				</div>
			</main>
			
			<footer>
				<nav class="navbar text-body">
					<div class="form-inline text-light" style="max-width: 550px;">
						<span v-if="lastHistory != null" class="pointer" @click="showHistoryBookstoreBillingModal">
							<i class="mr-1" :class="lastHistory.type_history.class + ' text-' + lastHistory.type_history.color"></i>
							{{ lastHistory.description }}
						</span>
					</div>
					<div class="form-inline">
						<div class="d-sm-inline">
							<i class=""
								:class="(objectBookstore.id > 0) ? 'fas fa-user-cog mr-1' : 'fas fa-user-times text-brown-red'"
								:title="(objectClient.id == 0) ? 'Primero hay que definir la libreria' : 'Doble click para cambiar el cliente'"
								@dblclick="showFormClientLocal"></i>
							<span v-if="objectClient.id > 0">{{ objectClient.name }} {{ objectClient.surname }}</span>
						</div>
						<div class="float-right d-none d-sm-inline separator"></div>
						<div class="d-sm-inline menu-item" :class="(showListBookstores) ? 'menu-item-click' : ''">
							<i class="fas fa-store mr-1"
								:class="(objectBookstore.id == 0) ? 'text-brown-red' : ''"
								@dblclick="showListBookstoresMenus()"></i>
								<div class="submenu text-left">
								<div class="pointer"
									v-for="(item, index) in listBookstoresFilter" :key="index"
									v-if="objectBookstore.id != item.id"
									@click="setObjectBookstoreLocal(item)"
									v-click-outside="clickOutsideSubmenuListBookstores">{{ item.name }}</div>
							</div>
							<span v-if="objectBookstore.id == 0" class="text-brown-red">Sin Definir</span>					
							<span v-else>{{ objectBookstore.name }}</span>
						</div>
						<div class="float-right d-none d-sm-inline separator"></div>
						<div class="d-sm-inline menu-item" :class="(showListPrinters) ? 'menu-item-click' : ''">
							<i class="fas fa-print mr-1"
								:class="(!successFullConnectionFacturacionCLPrint) ? 'text-brown-red' : ''"
								@dblclick="selectPrinterInvoiceLocal(-1)"
								:title="(successFullConnectionFacturacionCLPrint) ? 'Doble click para seleccionar otra impresora' : 'Doble click para tratar de conectar'"></i>
							<span>
								<span :class="(!successFullConnectionFacturacionCLPrint) ? 'text-brown-red' : ''"
									v-if="(!successFullConnectionFacturacionCLPrint)">Sin Conexión</span>
								<span v-else>
									<span v-if="indexSelectedPrinterFacturacionCLPrint > -1">
										{{ listPrinterFacturacionCLPrint[indexSelectedPrinterFacturacionCLPrint] }}
									</span>
									<span v-else>
										No hay impresora Seleccionada
									</span>
								</span>
							</span>
							<div class="submenu text-left">
								<div class="pointer"
									v-for="(item, index) in listPrinterFacturacionCLPrint" :key="index"
									v-if="index != indexSelectedPrinterFacturacionCLPrint"
									@click="selectPrinterInvoiceLocal(index)"
									v-click-outside="clickOutsideSubmenuListPrinters">{{ item }}</div>
							</div>
						</div>
						<div class="float-right d-none d-sm-inline separator"></div>
						<i class="fas fa-calendar-alt mr-2"></i>
						<span>2023-08-09</span>
						<div class="float-right d-none d-sm-inline separator"></div>
						<i class="fas fa-question-circle pointer" title="Ayuda" :class="(getEnvironmentCurrent == 'development') ? 'text-muted' : ''"></i>
					</div>
				</nav>
			</footer>

			<!-- Totales -->
			<div class="totals" @click="goToInputPrincipal" v-if="objectOrder.order_products.length > 0">
				<div class="row mb-2">
					<div class="col-7">
						<h4>
							Total
							<span class="float-right">$</span>
						</h4>
					</div>
					<div class="col-5 text-right">
						<h4>{{ methodFormatNumber(totalObjectOrderProducts) }}</h4>
					</div>
				</div>
				<div class="row mb-3" v-show="totalDiscountObjectOrderProducts < 0">
					<div class="col-7">
						<h4>
							Descuento
							<span class="float-right">$</span>
						</h4>
					</div>
					<div class="col-5 text-right">
						<h4>{{ methodFormatNumber(totalDiscountObjectOrderProducts) }}</h4>
					</div>
				</div>
				<div class="text-center mb-2">
					<div class="mb-1"><h5>a Pagar</h5></div>
					<div><h1>$ {{ methodFormatNumber(totalToPayment) }}</h1></div>
				</div>
				<div class="container text-center mb-2">
					<button class="button" @click="showPaymentModalLocal" :disabled="disabledBntShowPaymentModalLocal" ref="bntShowPaymentModal"><i class="fas fa-cash-register"></i> Pagar</button>
				</div>
				<div class="text-right" v-if="(totalObjectOrderPayments - totalToPayment) > 0">
					<h5>
						Vuelto: $ <span :class="((totalObjectOrderPayments - totalToPayment) < 0) ? 'text-danger' : 'text-dark'">{{ methodFormatNumber(totalObjectOrderPayments - totalToPayment) }}</span>
					</h5>
				</div>
			</div>
		</div>
		<div v-else class="text-center text-white mt-3">
			<h5 class="mb-2">
				Cargando configuraciones iniciales
			</h5>
			<div class="text-center">
				<span v-if="lastHistory != null" class="pointer" @click="showHistoryBookstoreBillingModal">
					<i class="mr-1" :class="lastHistory.type_history.class + ' text-' + lastHistory.type_history.color"></i>
					{{ lastHistory.description }}
				</span>
			</div>
		</div>

		<!-- Modal Type Payment -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#paymentModal" ref="btnShowPaymentModal" v-show="false">
			Launch demo modal
		</button>
		<div class="modal fade payment-modal" id="paymentModal" data-backdrop="static" data-keyboard="false" aria-hidden="true" tabindex="-1" aria-labelledby="exampleModalLabel">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-body text-muted">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePaymentModalLocal">
							<span aria-hidden="true">&times;</span>
						</button>
						<h5 class="modal-title text-center text-muted mb-4" id="exampleModalLabel">Formas de Pago - a pagar : $ {{ methodFormatNumber(totalToPayment) }}</h5>
						<div class="row text-center type-payments mb-2">

							<div class="col-md-4 mb-2 type-payment" v-for="(item, index) in listTypePaymentsFilter" :key="index">
								<div :class="'border border-' + item.color + ' p-2 text-' + item.color" @click="addListPaymentsLocal(item)">
									<div class="icon">
										<i :class="'fas ' + item.class"></i>
									</div>
									<div>
										{{ item.name }}
										<i class="fas fa-check-circle float-right text-success" v-if="existsTypePaymentListOrderPayment(item.id)"></i>
									</div>
								</div>
							</div>
						</div>
						<hr>
						<div class="payments">
							<h5 class="text-center mb-1">Pagos</h5>
							<div>
								<table class="table">
									<thead>
										<tr>
											<th class="text-center">#</th>
											<th class="text-center">Forma de Pago</th>
											<th class="text-center">Monto</th>
											<th class="text-center">Banco</th>
											<th class="text-center">Codigo</th>
											<th class="text-center">Descipcion</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(item, index) in objectOrder.order_payments" :key="index">
											<td>{{ index + 1 }}</td>
											<td>{{ item.typePayment.name }}</td>
											<td>
												<input type="text" class="text-right amount" :ref="'inputAmount' + index" v-model="item.amount" @focus="$event.target.select()">
											</td>
											<td>
												<select v-show="item.typePayment.listBanks.length > 0" v-model="item.bank_id">
													<option v-for="(ite, inde) in item.typePayment.listBanks" :key="inde" :value="ite.id">{{ ite.name }}</option>
												</select>
											</td>
											<td>
												<input type="text" class="text-center code" v-model="item.code">
											</td>
											<td><input type="text" class="description" v-model="item.description"></td>
											<td class="text-right actions">
												<i class="far fa-trash-alt text-dark" @click="removeListPaymentsLocal(index)"></i>
											</td>
										</tr>
									</tbody>
									<tfoot>
										<tr style="font-size: 20px;">
											<th class="text-right" colspan="2">Total $</th>
											<th class="text-right">{{ methodFormatNumber(totalObjectOrderPayments) }}</th>
											<th class="text-right" colspan="4">
												Vuelto $ 
												<span :class="((totalObjectOrderPayments - totalToPayment) < 0) ? 'text-danger' : 'text-success'">{{ methodFormatNumber(totalObjectOrderPayments - totalToPayment) }}</span>
											</th>
										</tr>
									</tfoot>
								</table>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closePaymentModalLocal">Cerrar</button>
						<button type="button" class="btn btn-primary"><i class="far fa-save"></i> Guardar</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal History Bookstore Billing -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#historyBookstoreBillingModal" ref="btnShowHistoryBookstoreBillingModal" v-show="false">
			Launch demo modal
		</button>		
		<div class="modal fade" id="historyBookstoreBillingModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" @click.self="goToInputPrincipal">
			<div class="modal-dialog modal-lg modal-dialog-scrollable">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="historyBookstoreBillingModalLabel">Historial</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div>
							<table class="table table-sm table-12 table-hover table-striped">
								<thead>
									<tr>
										<th class="text-center">Descripcion</th>
										<th class="text-center">Fecha</th>
										<th class="text-center">Guardado</th>
									</tr>
								</thead>
								<thead>
									<tr v-for="(item, index) in listHistoryBookstoreBillingFilter" :key="index">
										<td>
											<i class="mr-1" :class="item.type_history.class + ' text-' + item.type_history.color"></i>
											{{ item.description }}
										</td>
										<td class="text-center">{{ item.date }}</td>
										<td class="text-center">{{ item.save }}</td>
									</tr>
								</thead>
							</table>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal Select Bookstore -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#selectBookstoreModal" ref="btnShowSelectBookstoreModal" v-show="false">
			Show Bookstore Modal
		</button>
		<div class="modal fade" id="selectBookstoreModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="selectBookstoreModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-sm">
				<div class="modal-content">
					<div class="modal-header" v-show="false">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="btnCloseSelectBookstoreModal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<button type="button" class="btn btn-lg btn-outline-secondary btn-block"
							@click="selectBookstoreLocal(item)"
							v-for="(item, index) in listBookstoresFilter"
							:key="index">{{ item.name }}</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal Form Client -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#formClientModal" ref="btnShowFormClientModal" v-show="false">
			Show Bookstore Modal
		</button>
		<div class="modal fade" id="formClientModal" tabindex="-1" data-backdrop="static" data-keyboard="false" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Formulario de Cliente</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="btnCloseFormClientModal" @click="closeFormClientModal">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<form-client
						:id="objectClient.id"
						:optionalDocumentNumber="false" ref="formClient"
						@actionSaveClient="saveClientLocal"></form-client>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import bookstoreBilling from '@/mixins/sales/bookstoreBilling.js'
import FormClient from '@/components/FormClient.vue'

export default {
	name: 'BookstoreBilling',
	mixins: [bookstoreBilling],
	data() {
		return {
			max: 10,
			widthMain: 0,
			showListPrinters: false,
			showListBookstores: false,
			inputPrincipalFocus: false
		}
	},
	components: {
		'form-client': FormClient,
	},
	computed: {
	},
	methods: {
		initModuleBookstore() {
			this.addListHistoryBookstoreBilling({type_history_id: 1, description: 'Modulo de Facturación Rápida', save: false, date: this.currentDate(0, true)})
			this.widthMain = screen.width - 400 + 'px'
			this.$refs.formClient.$refs.btnSetInitial.click()
		},
		actionInputPrincipalFocus(e) {
			e.target.select()
			this.inputPrincipalFocus = true
		},
		addListPaymentsLocal(item) {
			let index = this.addListPayments(item)
			if(index > -1) {
				setTimeout(() => { this.$refs['inputAmount' + index][0].focus() }, 100)
			}
		},
		clickOutsideSubmenuListPrinters() {
			this.showListPrinters = false
		},
		clickOutsideSubmenuListBookstores() {
			this.showListBookstores = false
		},
		closeFormClientModal() {
			this.$refs.formClient.$refs.btnNewClient.click()
			setTimeout(() => {this.goToInputPrincipal()}, 100)
		},
		closePaymentModalLocal() {
			this.clearListPaymentsWith0()
			setTimeout(() => {this.goToInputPrincipal()}, 100)
		},
		existsTypePaymentListOrderPayment(id) {
			let index = this.objectOrder.order_payments.map(e => parseInt(e.type_payment_id)).indexOf(parseInt(id))
			return index > -1
		},
		finishedLoadLocalBookstore() {
			this.goToInputPrincipal()
		},
		goToInputPrincipalKeydownCtrlLocal(e) {
			this.goToInputPrincipalKeydownCtrl(e)
			if(e.ctrlKey) {
				switch (e.keyCode) {
					case 80:
						this.$refs.btnShowPaymentModal.click()						
						break;
					case 83:
						console.log('Guardar Orders')
						break;
					default:
						break;
				}
			}
			if(e.ctrlKey && e.keyCode == 80) {
			}
		},
		newClientBookstoreBillingModule() {
			this.$refs.btnShowFormClientModal.click()
			this.$refs.formClient.$refs.btnNewClient.click()
		},
		removeListPaymentsLocal(index) {
			this.removeListPayments(index)
		},
		saveClientModal(data) {
			this.$refs.btnCloseFormClientModal.click()
		},
		selectBookstoreLocal(item) {
			this.setStoreBookstoreBilling(item)
			this.$refs.btnCloseSelectBookstoreModal.click()
			this.getAllTypePaymentsLocal()
		},
		selectPrinterInvoiceLocalFrontend() {
			if(this.showListPrinters == false) {
				this.showListPrinters = true
			} else {
				this.showListPrinters = false
			}
		},
		setObjectBookstoreLocal(item) {
			this.addListHistoryBookstoreBilling({type_history_id: 1, description: 'Se cambio a ' + this.objectBookstore.name, save: false, date: this.currentDate(0, true)})
			this.setStoreBookstoreBilling(item)
			this.clearObjectOrder()
			this.clickOutsideSubmenuListBookstores()
			this.goToInputPrincipal()
		},
		showHistoryBookstoreBillingModal() {
			this.$refs.btnShowHistoryBookstoreBillingModal.click()
		},
		showListBookstoresMenus() {
			if(this.listBookstoresFilter.length > 0) {
				if(this.listBookstoresFilter.length == 1 && this.objectBookstore.id > 0) {
					this.showListBookstores = false
				} else {
					this.showListBookstores = !this.showListBookstores
				}
			} else {
				this.showListBookstores = false
			}
		},
		showFormClientModel(){
			if(this.objectClient.id == 1) {
				this.addListHistoryBookstoreBilling({type_history_id: 4, description: 'No se puede editar ' + this.objectClient.name + ' ' + this.objectClient.surname, save: false, date: this.currentDate(0, true)})
				this.goToInputPrincipal()
			} else {
				this.$refs.btnShowFormClientModal.click()
				this.$refs.formClient.$refs.btnShowClient.click()
			}
		},
		showPaymentModalLocal() {
			this.$refs.btnShowPaymentModal.click()
		}
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">

.bookstore-billing {
	width: 100%;
	min-height: 100vh;
	display: flex;
	overflow: auto;
	flex-direction: column;

	header {
		color: #fff;
		text-align: center;
		padding: 10px 0;
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 1;

		.input-principal {
			background: transparent;
			width: 100%;
			caret-color: transparent;
			font-size: 18px;
		}

		.input-principal::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
			color: #333;
			opacity: 1; /* Firefox */
		}

		.text-white-placeholder::placeholder {
			color: #f00;
		}
	}
	
	main {
		color:#fff;
		padding: 40px;
		flex: 1;
		overflow-y: auto;
		.list {
			.item {
				.it {
					.product-name, .product-quantity, .product-price, .product-discount, .total-item {
						font-size: 20px;
					}

					.product-quantity, .product-price, .product-discount, .total-item, .icon {
						display: flex;
						justify-content: right;
						align-items: center;
						height: 100%;
					}

					.icon>i {
						cursor: pointer;
						opacity: .8;
					}

					.icon>i:hover {
						opacity: 1;
					}
				}
			}

			.item:last-child {
				border-bottom: none;
			}
		}

	}
	
	footer {
		background-color: #00808a;
		color: #fff;
		text-align: center;
		position: fixed;
		bottom: 0;
		width: 100%;
		.menu-item {
			.submenu {
				display: none;
				position: absolute;
				bottom: 35px;
				transform: translateX(-15px);
				background-color: #00808a;
				width: auto;
				padding: 10px;
				border-radius: 2px;
				border: 1px #007c81 solid;
			}
		}
		.menu-item-click {
			.submenu {
				display: block;
			}
  		}
	}

	.totals {
		z-index: 1;
		background-color: #00808a;
		padding: 20px;
		position: fixed;
		top: 20px;
		right: 10px;
		box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2); /* Agrega sombra */
		border-radius: 5px;
		color: #ffffcc;
		width: 370px;

		.button {
			display: inline-block;
			background-color: #00808a;
			color: #fff;
			padding: 10px 20px;
			border: none;
			border-radius: 5px;
			cursor: pointer;
			font-size: 28px;
		}

		.button:hover {
			background-color: #00666d; /* Color más oscuro al hacer hover */
		}
	}

	.payment-modal {
		.modal-body{
			.type-payments{
				.type-payment {
					cursor: pointer;
					opacity: 0.6;
					.icon{
						font-size: 32px;
					}
				}
				.type-payment:hover {
					color: #333;
					opacity: 1;
				}
			}

			.payments {
				input.amount, input.code {
					width: 100px;
				}

				input.description {
					width: 100%;
				}

				.actions {
					i {
						opacity: 0.8;
					}

					i:hover {
						opacity: 1;
						cursor: pointer;
					}
				}
			}
		}
	}
}
</style>